import { ConvexReactClient } from "convex/react";

/**
 * Convex Client (single instance)
 * ================================
 * Replaces tRPC httpBatchLink. Reads VITE_CONVEX_URL from env (set by
 * `npx convex dev` / Vercel env). Auth state managed by @convex-dev/auth.
 */
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

if (!convexUrl) {
  // eslint-disable-next-line no-console
  console.error(
    "[convex] VITE_CONVEX_URL is not set. Run `npx convex dev` to generate it."
  );
}

export const convex = new ConvexReactClient(convexUrl ?? "");

/**
 * Re-export of the generated `api` object so callers do
 *   import { useApi } from "@/lib/convex";
 * and avoid hard-coding the `@/convex/_generated/api` path everywhere.
 *
 * TODO(F3-2): uncomment after `npx convex codegen` produces _generated/.
 */
// export { api as useApi } from "@/convex/_generated/api";
export const useApi = (): never => {
  throw new Error("api not generated yet — run `npx convex codegen`");
};
